import { useMemo } from "react";
import useDim from "src/hooks/useDim";

const useGatheringHomeNumColumnsRange = () => {
	const dim = useDim();

	return useMemo(() => {
		const minNumColumns = Math.min(Math.max(Math.floor(dim.width / 250), 2), 8);

		return {
			minNumColumns,
			defaultNumColumns: minNumColumns,
			maxNumColumns: Math.max(2 * minNumColumns, 6),
		};
	}, [dim.width]);
};
export default useGatheringHomeNumColumnsRange;
